import Catering from './Catering'

export default Catering
